import { Auth } from "../classes/auth";
import CoreAPI from "./coreAPI";

export default function APIAuth(api: CoreAPI) {
  return {
    async changePassword(params: { accessToken: string; previousPassword: string; proposedPassword: string }) {
      return api.call({
        method: "POST",
        endpoint: "/auth/changePassword",
        body: params,
      });
    },
    async login(credentials: { password: string; username: string }) {
      return api.call<{
        userId: string;
        authenticationResponse: Auth;
      }>({
        method: "POST",
        endpoint: "/auth/login",
        body: {
          username: credentials.username,
          password: credentials.password,
        },
      });
    },
    async forgotPassword(username: string) {
      return api.call<{
        deliveryMedium: string;
        attributeName: string;
        destination: string;
      }>({
        method: "POST",
        endpoint: "/auth/forgotPassword",
        body: { username },
      });
    },
    async resetPassword(params: { confirmationCode: string; password: string; username: string }) {
      return api.call({
        method: "POST",
        endpoint: "/auth/resetForgotPassword",
        body: params,
      });
    },
    async signup(params: {
      email: string;
      firstName: string;
      lastName: string;
      password: string;
      phoneNumber: string;
      employerName?: string;
      partnerName?: string;
      currentEmployee: boolean;
      shouldSendNotification?: boolean;
    }) {
      return api.call({
        method: "POST",
        endpoint: "/auth/signup",
        body: {
          ...params,
          shouldSendNotification: params.shouldSendNotification !== undefined ? params.shouldSendNotification : true,
        },
      });
    },
    async verifyEmail(email: string) {
      return api.call({
        method: "POST",
        endpoint: "/auth/verifyEmail",
        body: { email },
      });
    },
    async resendVerificationEmail(email: string) {
      return api.call({
        method: "POST",
        endpoint: "/auth/sendEmailVerification",
        body: { email },
      });
    },
  };
}
